import { authedFetch } from '../lib/authedFetch';

const SESSION_KEY = 'shadowland-usage-session';
const FLUSH_DELAY_MS = 900;
const MAX_QUEUE = 20;

let queue = [];
let flushTimer = null;

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'unavailable';
  }
}

function compactRoute(route) {
  return String(route || window.location.pathname || '/').split('?')[0];
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    flushUsageEvents();
  }, FLUSH_DELAY_MS);
}

export function trackUsageEvent(eventName, options = {}) {
  if (!eventName || typeof window === 'undefined') return;
  queue.push({
    eventName,
    category: options.category || 'interaction',
    route: compactRoute(options.route),
    target: options.target || null,
    durationMs: options.durationMs,
    metadata: options.metadata || {},
    sessionId: getSessionId(),
  });
  if (queue.length >= MAX_QUEUE) {
    flushUsageEvents();
  } else {
    scheduleFlush();
  }
}

export async function flushUsageEvents() {
  if (!queue.length) return;
  const events = queue.splice(0, MAX_QUEUE);
  try {
    const res = await authedFetch('/api/usage-events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events }),
    });
    if (!res.ok && res.status !== 202) {
      queue = events.concat(queue).slice(0, MAX_QUEUE);
    }
  } catch {
    queue = events.concat(queue).slice(0, MAX_QUEUE);
  }
}
